class Editor {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){
    $('.c-editor p, .c-editor div').each(function(index, el) {
      if(el.textContent == ' ' || el.textContent == '') {
        el.style.height = '1px';
        el.style.marginTop = '1.5rem';
      }
    })

    $('[class*="wp-image"]').each(function(index, el) {
      el.style.width = Number(el.offsetWidth) * 0.1 + 'rem';
      el.style.height = 'auto';
    })

  }
}